<template>
  <div id="app">
    <div class="LBannerDakar">
      <div onclick="window.open('https://www.lrytas.lt')" class="LBannerDakar__logo">
        <svg viewBox="0 0 715.3 200" class="LLogo__svg" width="125" height="36"><path d="M575.5 80.5v57c0 2.2.2 4.4.5 6.6.4 3.1 2 4.6 5 5 1.9.3 3.8.4 5.6.5 1.8 0 1.6 1.1 1.7 2.3 0 1.2-.2 2.1-1.7 2-2.3-.1-4.7 0-7 0-12.5.1-25 .2-37.5.4-1.2 0-1.9-.2-1.8-1.5.1-1.2-.5-2.6 1.6-2.8 1.7-.1 3.4-.4 5-.8 1.9-.6 3.1-2 3.3-4 .2-2.4.4-4.8.4-7.2V38.7v-.2c0-6.4-1.3-7.7-7.6-8.2-2.2-.2-2.4-.5-2.3-2.7.1-1.5.8-1.9 2.2-2 10.5-.7 20.8-2.4 30.6-6.5 1.7-.7 2.1-.4 2.1 1.8-.1 19.8-.1 39.7-.1 59.6z" data-v-b8eaffd2=""></path> <path d="M603.4 103.8V75c0-1.7-.4-2.4-2.2-2.3-3 .1-5.9 0-8.9 0-1.2 0-2-.3-1.8-1.7.1-1.2-.6-2.8 1.6-3 9.5-.8 15.9-6.1 20.7-13.9 3.8-6.1 5.9-12.8 7.2-19.8.3-1.9 1-2.7 3-2.7 5.2.1 4.6-.3 4.6 4.6v30.1c0 1.8.5 2.4 2.3 2.4 5.2-.1 10.5 0 15.7 0 2.4 0 2.5.1 2.5 2.4 0 1.6-.1 3.3 0 4.9.1 1.6-.6 2.1-2.1 2.1h-16.1c-1.8 0-2.4.4-2.4 2.3.1 14.4 0 28.8.1 43.1 0 3.4.5 6.8 1.4 10 1.5 5 5.4 6.7 10.1 4.3 2.3-1.2 4.4-3.1 6.3-4.9 1.1-1 1.7-1.3 3-.4 2.9 2 3 2 .8 5-3.4 4.7-7.1 9.1-11.9 12.6-5.9 4.2-12.4 4.5-19 3.1-8.6-1.9-13.4-7.3-14.1-16.4-.6-7.5-.5-15-.7-22.5-.2-3.4-.1-7-.1-10.5z" data-v-b8eaffd2=""></path> <path d="M518.1 154.5c-11-.1-19.6-8.9-19.6-19.8.1-10.8 9.1-19.7 19.8-19.5 10.8.1 19.6 9.1 19.6 19.7-.1 11-8.9 19.7-19.8 19.6z" data-v-b8eaffd2=""></path> <path d="M185.4 73.7c.9 2.8 2.2 5.6 2.8 8.5 1.1 6-2.8 12.1-8.2 13.7-4.1 1.2-8-.2-10.4-3.8-2.8-4.2-6.2-4.7-10.1-1.5-3.5 2.9-5.4 6.8-6.4 11.1-.7 3.3-1.2 6.7-1.2 10.1-.1 9.8.1 19.5.2 29.3v.6c.3 4.9 2.2 6.9 7.1 7.2 1.3.1 2.6.1 4 .1 1.7 0 1.5 1.3 1.5 2.4 0 1.1.2 2.4-1.6 2.4-1.5 0-3-.1-4.5-.1-13.2 0-26.5.1-39.7.1-1.4 0-2.1-.3-2.1-1.9 0-1.3.1-2.5 1.8-2.3.4 0 .8 0 1.1-.1 5.5-.7 7.2-2.3 7.3-7.9.2-8.9.1-17.8.1-26.7V87.1c0-1 0-2-.1-3-.3-3.6-1.6-5.1-5.1-5.7l-2.4-.3c-2.3-.3-3.2-1.6-2.2-3.7.3-.5 1.3-.8 2-.9 5.9-.8 11.8-1.3 17.6-2.5 4.3-.9 8.4-2.5 12.6-3.9 2-.7 2.3-.5 2.3 1.7-.2 6.6-.4 13.1-.5 19.7 0 .4.1.8.5 1.4.4-.6.8-1.1 1.1-1.7 2.7-5 5.8-9.8 9.8-13.9 3.9-4 8.5-6 14.2-5.9 14.7.2 29.4.1 44.1.1h8.5c1.3 0 2.3.2 2.2 1.8-.1 1.4.2 2.8-2 2.9-1.3 0-2.7.2-3.9.5-4.1 1-5.6 3.6-4.4 7.6 1.1 3.8 2.4 7.6 3.5 11.4 3.5 11.3 7.1 22.6 10.6 33.9.2.6.5 1.1.7 1.6h.5c.7-1.8 1.3-3.6 2-5.4 4.3-12.3 8.7-24.6 12.8-37 .8-2.5 1.2-5.1 1.4-7.8.2-2.3-1.2-3.8-3.5-4.3-1.6-.3-3.2-.6-4.9-.7-2.1-.1-1.7-1.6-1.7-2.9-.1-1.3.6-1.8 1.8-1.8 8 0 16 0 24 .1.6 0 1.6.8 1.6 1.3.1 1.2.8 3.1-1 3.4-4.9 1-6.8 4.8-8.2 8.8-6.6 18.8-13.1 37.6-19.8 56.4-3.6 10.2-7.3 20.4-11.1 30.6-.8 2.2-2.1 4.3-3.3 6.4-5 8.9-17.5 11.7-24.8 8.5-3.8-1.6-6.3-4.2-6.8-8.4-.6-5.7 3.9-9.4 10.3-8.7 1 .1 2 .4 3 .6 2.7.6 5.4 1.4 8.1 1.7 6.6.8 10.2-4 7.8-10.2-2.5-6.5-4.9-13.1-7.4-19.6-5.8-15.3-11.5-30.6-17.4-45.8-2.1-5.3-4.6-10.4-7.1-15.4-1.7-3.7-2.8-4.2-7.1-4.3z" data-v-b8eaffd2=""></path> <path d="M385.4 137.4c-.3.6-.7 1.3-.9 1.9-3.9 10.1-13.8 16-25.4 15.1-9-.7-17.8-8.7-19.6-18.2-1.4-7.3 1.1-13.7 6.1-19.1 5.2-5.6 12-9 18.9-11.9 5-2.1 10-4.1 15.1-6.1 4.3-1.7 5.8-3.8 5.7-8.3 0-3.2-.3-6.4-.8-9.6-.5-2.9-2.3-4.9-5.1-5.8-2.9-1-6-1-8.9-.1-2.7.8-4.2 2.9-4.8 5.6-.4 2.2-.7 4.4-.9 6.5-.8 8.1-4.3 10.3-12.4 10-7.8-.3-12.1-8-9.1-15.8 1.9-4.9 5.6-8.1 10.3-9.9 13.5-5.4 27.5-6.4 41.5-2.2 9.2 2.7 14.2 9.7 14.4 19.4.3 9.8.1 19.5.2 29.3 0 4.2-.1 8.5.1 12.7.1 2 .5 4.1 1.2 6 .7 2.1 2.7 2.7 4.6 1.5 1.1-.7 2.2-1.5 3.2-2.4 1.4-1.2 2.2.1 3 .8.4.3.6 1.5.3 1.8-3.5 4.7-7.2 9.3-12.1 12.6-5.9 3.9-13.9 3.2-18.5-1.5-2.5-2.5-3.7-5.8-4.6-9.2-.3-1-.5-2-.8-3.1-.3.1-.5.1-.7 0zm-1-20.8V106c0-1.5-.5-1.9-1.8-1.2-1 .5-1.9.9-2.9 1.4-4.2 2.1-8.3 4.3-11.6 7.7-5.8 5.8-6.8 16-2.3 22.1 1.7 2.3 4.1 3.4 6.9 3.1 5.8-.6 11.9-6.1 11.7-13-.1-3.2 0-6.4 0-9.5z" data-v-b8eaffd2=""></path> <path d="M99.6 80.4v57c0 2.1.1 4.2.4 6.2.4 3.3 2 5 5.2 5.5 1.7.3 3.4.4 5.1.4 1.7 0 2.2.7 2.2 2.3 0 1.5-.6 2.2-2.1 2.1-1.5-.1-3 0-4.5 0-13.2.1-26.4.2-39.5.4-1.3 0-1.9-.4-1.9-1.7.1-1.2-.3-2.5 1.6-2.6 1.6-.1 3.2-.2 4.7-.7 2-.5 3.4-1.9 3.7-4.1.2-1.3.4-2.6.4-3.9V38.2v-1.7c-.2-3.7-1.5-5.2-5.1-5.9-.7-.1-1.5-.2-2.3-.2-2.5-.2-2.6-.5-2.5-2.9.1-1.3.7-1.7 1.9-1.8 10.6-.6 20.9-2.4 30.8-6.4 1.8-.7 2.1-.4 2.1 1.8-.2 19.7-.2 39.5-.2 59.3z" data-v-b8eaffd2=""></path> <path d="M287.9 103.2V75.6c0-2.7 0-2.7-2.8-2.7h-8.3c-1.4 0-1.9-.7-1.8-2 .1-1.2-.3-2.6 1.7-2.8 9.5-.8 16-6.2 20.7-14.1 3.6-6 5.8-12.6 7-19.5.5-2.7.5-2.7 3.3-2.7 4.8 0 4.2-.6 4.2 4.2v30.5c0 1.8.5 2.4 2.3 2.4 5.4-.1 10.7 0 16.1-.1 1.6 0 2.3.5 2.3 2.1-.1 1.7-.1 3.4 0 5.1.1 1.6-.5 2.2-2.2 2.2-5.3-.1-10.6 0-15.9 0-2.6 0-2.5 0-2.6 2.5 0 14.1-.1 28.1.1 42.2 0 3.5.5 7.1 1.4 10.4 1.4 5.4 5.7 7.2 10.5 4.6 2.2-1.2 4.2-3 6-4.8 1-1 1.7-1.4 3-.5 3.3 2.3 3.3 1.8.9 5-4.1 5.6-8.3 11.3-14.9 14.2-8 3.6-16 3-23.4-1.7-3.9-2.5-5.6-6.6-6.4-11-.7-3.8-1-7.8-1.1-11.6-.2-8.1-.1-16.2-.1-24.3z" data-v-b8eaffd2=""></path> <path d="M425.8 123.1c0-1.6.5-2.1 2.1-2.1 4.1 0 3.4-.1 4.6 3.7 2.3 7.3 5.9 13.7 12.4 18 6.3 4.1 13.2 5 20.1 1.4 3.8-1.9 5.6-5.3 5.7-9.5.1-4.1-2.2-7-5.6-8.7-3.2-1.6-6.6-2.8-10-3.9-5.9-1.9-11.8-3.8-17.1-7-10.2-6.3-13.6-15.8-12.1-27.3 1.5-11.2 9.9-19.1 21.8-21 10.2-1.7 19.7-.1 28.4 5.8 2.8 1.9 5.9 1.5 6.6-2.2.3-1.7 1.6-1.2 2.7-1.3 1.3 0 1.4.9 1.4 1.8v22.9c0 1.3-.4 1.9-1.7 1.8h-.8c-3.2 0-3.2 0-4.4-2.9-2.3-5.7-5.7-10.7-10.7-14.4-5.1-3.8-10.7-5.2-16.9-2.8-3.9 1.5-6.5 4-6.7 8.5-.2 4.6 2.4 7.5 6.4 9.1 4.5 1.8 9.2 3.1 13.8 4.7 6.9 2.4 13.8 5 19 10.5 6.6 6.8 8.2 15.1 6.1 24-2.5 11-10.3 17.4-20.7 20.6-10.4 3.2-20.7 2.3-30.5-2.7-.9-.5-1.8-1.1-2.7-1.7-2.5-1.6-4.6-1-5.8 1.7-.4 1-.8 1.9-2.2 1.9-2.9.1-3.2-.1-3.2-3v-12.9" data-v-b8eaffd2=""></path></svg>
      </div>
      <div class="LBannerDakar__headline">DAKARAS<span>2023</span></div>
      <div class="LBannerDakar__content">
        <swiper :options="swiperOption" ref="mySwiper">
          <!-- slides -->
          <swiper-slide
            v-for="(driver, index) in items"
            :key="index"
          >
            <div class="LBannerDakar__card">
              <div class="LBannerDakar__cardImage">
                <img
                  :src="'https://api.lrytas.lt/dakaras-2022' + driver.photo.data.attributes.formats.thumbnail.url"
                >
              </div>
              <div class="LBannerDakar__cardBody">
                <div class="LBannerDakar__cardTitle">
                  {{ driver.name }}
                </div>
                <div class="LBannerDakar__cardStats">
                  <div class="LBannerDakar__cardStat">
                      <div>
                        VIETA
                      </div>
                      {{ driver.status.position === 999 ? 'N/A' : driver.status.position }}
                  </div>
                  <div class="LBannerDakar__cardStat">
                      <div>
                        KILOMETRAI
                      </div>
                      {{ driver.status.distance ? driver.status.distance : 'N/A' }}
                  </div>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper>
        <div class="LBannerDakar__arrow LBannerDakar__arrow--left">
          <svg xmlns="http://www.w3.org/2000/svg" width="12.035" height="8.329"><g fill="none" stroke="#543533" stroke-linecap="round"><path data-name="Path 1462" d="m8.082 7.621 3.457-3.457L8.082.707" stroke-linejoin="round"/><path data-name="Path 1463" d="M.5 4.164h10.714"/></g></svg>
        </div>
        <div class="LBannerDakar__arrow LBannerDakar__arrow--right">
          <svg xmlns="http://www.w3.org/2000/svg" width="12.035" height="8.329"><g fill="none" stroke="#543533" stroke-linecap="round"><path data-name="Path 1462" d="m8.082 7.621 3.457-3.457L8.082.707" stroke-linejoin="round"/><path data-name="Path 1463" d="M.5 4.164h10.714"/></g></svg>
        </div>
      </div>
      <div onclick="window.open('https://plus.lrytas.lt/dakaras-2023/')" class="LBannerDakar__bubble">
        <div>
          DAUGIAU
        </div>
        <svg xmlns="http://www.w3.org/2000/svg" width="8.329" height="4.664" viewBox="0 0 8.329 4.664">
          <path id="arrow-down" d="M-829.059,890.4l3.457,3.457,3.457-3.457" transform="translate(829.766 -889.688)" fill="none" stroke="#543533" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      swiperOption: {
        slidesPerView: 3.5,
        spaceBetween: 40,
        navigation: {
          nextEl: '.LBannerDakar__arrow.LBannerDakar__arrow--right',
          prevEl: '.LBannerDakar__arrow.LBannerDakar__arrow--left',
        },
        breakpoints: {
          1199: {
            slidesPerView: 1
          }
        }
      },
      items: []
    }
  },
  methods: {
    getData () {
      fetch('https://api.lrytas.lt/dakaras-2022/api/dalyviai-2023?populate[0]=drivers&populate[1]=drivers.status&populate[2]=drivers.details&populate[3]=drivers.photo')
      .then((resp) => resp.json())
      .then((data) => {
        console.log(data)
        this.items = data.data.attributes.drivers
          .map((driver) => {
            if (driver.status && driver.status.position && driver.status.position === 0) {
              driver.status.position = 999
            }
            if (!driver.status) {
              driver.status = {}
              driver.status.position = 999
            } else if (driver.status && driver.status.position === -1) {
              driver.status.position = 999
            }
            return driver
          })
          .sort((a, b) => a.status.position - b.status.position)
      })
      .catch((error) => {
        Error(error)
      })
    }
  },
  mounted () {
    this.getData()
  }
}
</script>
<style lang="scss">
  body {
    margin: 0;
  }
  *,
  *:after,
  *:before {
    box-sizing: border-box;
  }
</style>
<style lang="scss" scoped>
  .LBannerDakar {
    width: 1200px;
    height: 250px;
    background: url('https://plus.lrytas.lt/dakaras-widget-2022/bg-skirtukas-pc.png')#000 no-repeat center center / cover;
    font-family: 'Proxima Nova', sans-serif;
    position: relative;
    overflow: hidden;
    padding-top: 26px;
    padding-left: 26px;
    @media (max-width: 1199px) {
      width: 300px;
      height: 250px;
      padding-left: 33px;
      margin: 0 auto;
      padding-top: 43px;
      background: url('https://plus.lrytas.lt/dakaras-widget-2022/bg-skirtukas-mob.png')#000 no-repeat center center / cover;
    }
    &__logo {
      position: absolute;
      top: 33px;
      left: 26px;
      cursor: pointer;
      @media (max-width: 1199px) {
        top: 13px;
        left: 50%;
        transform: translateX(-50%);
      }
      svg {
        display: block;
        color: #fff;
        fill: #fff;
        @media (max-width: 1199px) {
          width: 76px;
          height: 22px;
        }
      }
    }
    &__content {
      padding-top: 30px;
    }
    &__card {
      padding-right: 40px;
      &:after {
        content: '';
        height: 100%;
        width: 1px;
        background: #FFFFFF;
        opacity: 0.3;
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        @media (max-width: 1199px) {
          display: none;
        }
      }
    }
    &__cardTitle {
      font-size: 16px;
      line-height: 18px;
      letter-spacing: 1.6px;
      color: #FFFFFF;
      text-shadow: 0px 3px 6px #00000029;
      text-transform: uppercase;
      margin-bottom: 7px;
      font-weight: 700;
      text-align: left;
    }
    &__cardStat {
      font-size: 24px;
      letter-spacing: 4.8px;
      line-height: 29px;
      color: #fff;
      text-shadow: 0px 3px 6px #00000029;
      & + & {
        margin-left: 24px;
      }
      > div {
        font-size: 12px;
        line-height: 15px;
        letter-spacing: 1.2px;
      }
    }
    &__cardImage {
      width: 74px;
      height: 74px;
      border-radius: 100%;
      flex-shrink: 0;
      margin-right: 19px;
      @media (max-width: 1199px) {
        margin-right: 9px;
      }
      img {
        object-fit: cover;
        object-position: top center;
        width: 100%;
        height: 100%;
        border-radius: 100%;
      }
    }
    &__card,
    &__cardStats {
      display: flex;
      align-items: center;
    }
    &__headline {
      font-size: 46px;
      letter-spacing: 23px;
      line-height: 1;
      color: #FFFFFF;
      text-align: center;
      @media (max-width: 1199px) {
        font-size: 27px;
        letter-spacing: 13.5px;
      }
      span {
        font-size: 12px;
        letter-spacing: 1.2px;
        line-height: 1;
        transform: matrix(0, -1, 1, 0, -25, -12);
        display: inline-flex;
        @media (max-width: 1199px) {
          font-size: 7px;
          letter-spacing: 0.7px;
          transform: matrix(0, -1, 1, 0, -14, -8);
        }
      }
    }
    &__cardBody {
      flex: 1;
    }
    &__arrow {
      box-shadow: 0px -3px 6px #00000029;
      background: #F1ECEC;
      height: 163px;
      width: 163px;
      border-radius: 100%;
      position: absolute;
      transform: translateY(-50%);
      top: 50%;
      z-index: 5;
      margin-top: 20px;
      @media (max-width: 1199px) {
        width: 74px;
        height: 74px;
      }
      svg {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 11px;
        display: block;
      }
      &.swiper-button-disabled {
        opacity: 0;
      }
      cursor: pointer;
      &--left {
        left: -130px;
        @media (max-width: 1199px) {
          left: -48px;
        }
        svg {
          transform: rotateY(180deg) translateY(-50%);
          right: 11px;
          left: auto;
        }
      }
      &--right {
        right: -130px;
        @media (max-width: 1199px) {
          right: -48px;
        }
      }
    }
    &__bubble {
      width: 215px;
      height: 215px;
      background: #F1ECEC;
      box-shadow: 0px -3px 6px #00000029;
      border-radius: 100%;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 80%);
      text-align: center;
      color: #543533;
      font-size: 12px;
      padding-top: 13px;
      letter-spacing: 1.2px;
      line-height: 15px;
      text-transform: uppercase;
      font-weight: 700;
      cursor: pointer;
      svg {
        display: block;
        margin: 5px auto 0 auto;
      }
    }
  }
</style>
